//Share function
let openShare = document.querySelector('#share-vid');
let shareBtns = document.querySelector('#share-btns');

openShare.addEventListener('click', function(event){
  event.preventDefault();
  this.classList.add('triggered');
  shareBtns.classList.add('triggered');
});

let vidLinks = document.querySelectorAll('.film-loop .film');
let vidModal = document.querySelector('#video-modal');
let vidConOne = vidModal.querySelector('#first-vid');
let vidConTwo = vidModal.querySelector("#second-vid");
let vidConThree = vidModal.querySelector("#third-vid");

var playerOne = new Vimeo.Player(vidConOne, {
  autoplay: false,
  playsinline: true,
  //muted: true,
});


var playerTwo = new Vimeo.Player(vidConTwo, {
  autoplay: false,
  playsinline: true,
  //muted: true,
});


var playerThree = new Vimeo.Player(vidConThree, {
  autoplay: false,
  playsinline: true,
  //muted: true,
});


let fullScreenBtn  = document.querySelector('#full-vid-desktop');
fullScreenBtn.addEventListener('click', function(event){
  event.preventDefault();
  //player.requestFullscreen();
});

let fullScreenMobileBtn  = document.querySelector('#full-vid-mobile');
fullScreenMobileBtn.addEventListener('click', function(event){
  event.preventDefault();
  //player.requestFullscreen();

      if (activeVideo == 0) {
        playerOne.requestFullscreen();
      }
      if (activeVideo == 1) {
        playerTwo.requestFullscreen();
      }
      if (activeVideo == 2) {
        playerThree.requestFullscreen();
      }

  let playBtn = document.querySelector("#play-vid");
    if (playBtn.innerHTML === "Pause") {
      playBtn.innerHTML = "Play";
      //player.setVolume(1);
      //player.pause();

      if (activeVideo == 0) {
        playerOne.pause();
      }
      if (activeVideo == 1) {
        playerTwo.pause();
      }
      if (activeVideo == 2) {
        playerThree.pause();
      }

    } else {
      playBtn.innerHTML = "Pause";
      //player.play();
      //player.setVolume(1);

      if (activeVideo == 0) {
        playerOne.play();
      }
      if (activeVideo == 1) {
        playerTwo.play();
      }
      if (activeVideo == 2) {
        playerThree.play();
      }

    }
});

let closeVidBtn = document.querySelector('#close-vid');


// player.on('fullscreenchange', function(data) {
//   console.log(data);
//   console.log("full Screen changeo")
//   
// });

let activeVideo = 0;

vidLinks.forEach(function(item, i){

  item.addEventListener('click', function(event){
    event.preventDefault();
    //let vidSrc = item.querySelector('.video-link').dataset.videoSrc;
    //vidCon.src = vidSrc;

    vidModal.classList.add('active');
    document.querySelector('body').classList.add('no-scroll');

    document.querySelectorAll(".vidcon iframe")[i].classList.add("appear");

    if(i == 0){
      playerTwo.pause();
      playerThree.pause();
      playerOne.play();
      console.log("First vid");
    }
    if(i == 1){
      playerOne.pause();
      playerThree.pause();
      playerTwo.play();
      console.log("Second vid");
    }
    if(i == 2){
      playerOne.pause();
      playerTwo.pause();
      playerThree.play();
      console.log("Third vid");
    }

    activeVideo = i;
    


    var delayInMilliseconds = 2000; //1 second
    setTimeout(function() {
    }, delayInMilliseconds);
  });
});

closeVidBtn.addEventListener('click', function(event){
  event.preventDefault();
  //vidCon.src = "";
  //player.pause();
  vidModal.classList.remove('active');
  document.querySelector('body').classList.remove('no-scroll');

  playerOne.pause();
  playerTwo.pause();
  playerThree.pause();

  let myVids = document.querySelectorAll(".vidcon iframe");

  myVids.forEach(function(jtem, j){
    if(jtem.classList.contains("appear")){
      jtem.classList.remove("appear");
    };
  });

  openShare.classList.remove('triggered');
  shareBtns.classList.remove('triggered');
});

//Custom Vimeo
let playBtn = document.querySelector("#play-vid");

  playBtn.addEventListener("click", function(event){
    event.preventDefault();

    if (playBtn.innerHTML === "Pause") {
      playBtn.innerHTML = "Play";
      console.log(activeVideo);

      if (activeVideo == 0) {
        playerOne.pause();
        console.log("First vid");
      }
      if (activeVideo == 1) {
        playerTwo.pause();
        console.log("Second vid");
      }
      if (activeVideo == 2) {
        playerThree.pause();
        console.log("Third vid");
      }

    } else {
      playBtn.innerHTML = "Pause";
      if (activeVideo == 0) {
        playerOne.play();
        console.log("First vid");
      }
      if (activeVideo == 1) {
        playerTwo.play();
        console.log("Second vid");
      }
      if (activeVideo == 2) {
        playerThree.play();
        console.log("Third vid");
      }
    }

});

document.addEventListener('fullscreenchange', (event) => {
  // // document.fullscreenElement will point to the element that
  // // is in fullscreen mode if there is one. If there isn't one,
  // // the value of the property is null.
  // if (document.fullscreenElement) {
  //   console.log(`Element: ${document.fullscreenElement.id} entered full-screen mode.`);
  // } else {
  //   console.log('Leaving full-screen mode.');
    
  // }
  //player.play();
});

/* Firefox */
// document.addEventListener("mozfullscreenchange", function() {
//   player.play();
// });

// /* Chrome, Safari and Opera */
// document.addEventListener("webkitfullscreenchange", function() {
//     player.play();
// });
